module.exports = "https://cdn.thelire.com/ins/resource/x.c21109168900cd1e2631deda6ec7ca50.png";